import React from "react";
import PropTypes from "prop-types";

export const Target2SellBloc = ({pId, espaceId}) => {
    return (
        <div className="target2sell" id={`PPNA1QL127P68J-${pId}-${espaceId}`}/>
    );
};

Target2SellBloc.propTypes = {
    pID: PropTypes.string,
    espaceID: PropTypes.string,

};

Target2SellBloc.defaultProps = {
    pID: null,
    espaceID: null,

};
